module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("account.labels.editProfile")))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "form-group form-avatar"
  }, [_c('span', {
    staticClass: "avatar avatar-lg"
  }, [(_vm.currentUser) ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.currentUser.display_image.sizes.default.url,
      "alt": "image-profile"
    }
  }) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/user.png",
      "alt": "image-profile"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("account.profile.labels.changeDisplayImage")) + " "), _c('a', {
    attrs: {
      "href": "http://www.gravatar.com",
      "target": "_blank"
    }
  }, [_vm._v("Gravatar.com")])])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('account.labels.displayName')
    },
    domProps: {
      "value": _vm._s(_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t(
        'account.labels.displayName'),
      "autocomplete": "false",
      "disabled": true
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.password")))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-icon btn-block btn-link text-xs-left p-l-0",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/self/password")
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("member.action.changePassword")) + "\n                    ")])], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('lang')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.profile.labels.chooseLanguage")))]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lang),
      expression: "user.lang"
    }],
    attrs: {
      "type": "radio",
      "value": "th"
    },
    domProps: {
      "checked": _vm._q(_vm.user.lang, "th")
    },
    on: {
      "click": function($event) {
        _vm.user.lang = "th"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputRadiosChecked"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.lang.th")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lang),
      expression: "user.lang"
    }],
    attrs: {
      "type": "radio",
      "value": "en"
    },
    domProps: {
      "checked": _vm._q(_vm.user.lang, "en")
    },
    on: {
      "click": function($event) {
        _vm.user.lang = "en"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputRadiosChecked"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.lang.en")))])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("account.action.submit")) + "\n                ")])])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d687c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/Profile.vue
// module id = 557
// module chunks = 1